import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly http = inject(HttpClient);

  public login(email: string, password: string): Observable<boolean> {
    return this.http.post<string>('/login', { email, password }).pipe(map(() => true));
  }

  public logout(): Observable<void> {
    return this.http.post<void>('/logout', {});
  }
}
